export const menuItems = (items) => {
    const order = [
        'Menu.occupancyMap',
        'Menu.students',
        'Menu.responsible',
        'Menu.classgrade',
        'Menu.teachingAreas',
        'Menu.team',
        'Menu.assessmentStudents', // Acesso do professor
        'Menu.downloads',
        'Menu.assessmentStudentsNewModule', // Novo Painel MGB
        'Menu.integration',
        'Menu.showStores',
        'Menu.courses',
        'Menu.certification',
        {
            name: 'Menu.SubItems.pedagogic',
            icon: 'icn_pedagogical',
            items: [
                'Menu.goals',
                'Menu.contents',
                'Menu.scheduleMap',
                'Menu.assessmentModel', // Acesso do pedagógico
                // 'Menu.library',
            ],
        },
        {
            name: 'Menu.SubItems.configurations',
            icon: 'icn_config',
            items: [
                'Menu.plans',
                'Menu.clients',
                'Menu.locations',
                'Menu.staff',
                'Menu.uploads',
                'Menu.partners',
                'Menu.partnerManagement',
            ],
        },
        'Menu.faq',
    ]
    const menu = []
    order.forEach((ord, i) => {
        if (typeof ord === 'string') {
            items.forEach((item) => {
                if (item.name === ord) menu.push(item)
            })
        } else {
            const sortingArray = ord.items
            const obj = {
                name: ord.name,
                items: items
                    .filter(({ name }) => ord.items.find((o) => o === name))
                    .slice()
                    .sort((a, b) => {
                        return (
                            sortingArray.indexOf(a.name) -
                            sortingArray.indexOf(b.name)
                        )
                    }),
                icon: ord.icon,
            }
            menu.push(obj)
        }
    })
    return menu
}
